import React, { useState } from 'react';
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import InfoBar from '../../components/InfoBar/InfoBar';
import './CustomerService.css';

export default function CustomerService() {
  const [activeFaq, setActiveFaq] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const faqs = [
    {
      id: 1,
      category: 'Orders & Delivery',
      question: 'What are your delivery hours?',
      answer: 'We deliver 6 days a week, Monday through Saturday. Same-day delivery is available for orders placed before 2 PM. Our delivery windows are 9 AM - 1 PM and 1 PM - 6 PM.'
    },
    {
      id: 2,
      category: 'Orders & Delivery',
      question: 'Do you offer same-day delivery?',
      answer: 'Yes! Same-day delivery is available for orders placed before 2 PM on weekdays and before 12 PM on Saturdays. This service may incur an additional fee depending on your location.'
    },
    {
      id: 3,
      category: 'Orders & Delivery',
      question: 'Can I track my order?',
      answer: 'Absolutely! Once your order is dispatched, you\'ll receive a tracking link via email and SMS. You can monitor your delivery in real-time and see the estimated arrival window.'
    },
    {
      id: 4,
      category: 'Products & Quality',
      question: 'How long will my flowers last?',
      answer: 'With proper care, our flowers typically last 7-10 days. We provide a 7-day freshness guarantee and include care instructions with every delivery. Keep them in fresh water, away from direct sunlight and heat sources.'
    },
    {
      id: 5,
      category: 'Products & Quality',
      question: 'What if the flowers arrive damaged?',
      answer: 'We take great care in packaging and delivery, but if your flowers arrive damaged, please contact us within 24 hours with photos. We\'ll arrange a replacement or full refund immediately.'
    },
    {
      id: 6,
      category: 'Products & Quality',
      question: 'Can I customize my bouquet?',
      answer: 'Yes! We offer customization for all our arrangements. You can add or remove specific flowers, change colors, add a personal message card, or include extras like chocolates or balloons.'
    },
    {
      id: 7,
      category: 'Payment & Pricing',
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards (Visa, Mastercard, American Express), PayPal, Apple Pay, Google Pay, and bank transfers for corporate accounts.'
    },
    {
      id: 8,
      category: 'Payment & Pricing',
      question: 'Do you offer discounts for bulk orders?',
      answer: 'Yes! We provide special pricing for bulk orders, subscriptions, and corporate accounts. Contact our business team for a custom quote tailored to your needs.'
    },
    {
      id: 9,
      category: 'Returns & Cancellations',
      question: 'Can I cancel or modify my order?',
      answer: 'Orders can be cancelled or modified up to 2 hours before the scheduled delivery time. Please contact us immediately if you need to make changes. No cancellation fees apply.'
    },
    {
      id: 10,
      category: 'Returns & Cancellations',
      question: 'What is your refund policy?',
      answer: 'If you\'re not completely satisfied with your order, please contact us within 24 hours. We offer full refunds or replacements for any quality issues or delivery problems.'
    }
  ];

  const contactMethods = [
    {
      id: 1,
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      ),
      title: 'Phone Support',
      description: 'Call us for immediate assistance',
      contact: '+1 (555) 123-4567',
      hours: 'Mon-Sat: 8 AM - 8 PM'
    },
    {
      id: 2,
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      ),
      title: 'Email Support',
      description: 'Send us a detailed message',
      contact: 'support@tulipink.com',
      hours: 'Response within 24 hours'
    },
    {
      id: 3,
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      ),
      title: 'Live Chat',
      description: 'Chat with our support team',
      contact: 'Available on website',
      hours: 'Mon-Sat: 9 AM - 6 PM'
    },
    {
      id: 4,
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      ),
      title: 'Visit Our Store',
      description: 'Come see our flowers in person',
      contact: '123 Flower Street, City',
      hours: 'Mon-Sat: 9 AM - 6 PM'
    }
  ];

  const toggleFaq = (id) => {
    setActiveFaq(activeFaq === id ? null : id);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Add form submission logic here
    alert('Thank you for contacting us! We\'ll get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const categories = [...new Set(faqs.map(faq => faq.category))];

  return (
    <>
      <InfoBar />
      <NavBar />
      <div className="customer-service-page">
        {/* Hero Section */}
        <section className="customer-service-hero">
          <div className="customer-service-hero-content">
            <h1 className="customer-service-hero-title">How Can We Help You?</h1>
            <p className="customer-service-hero-subtitle">
              We're here to assist you with any questions or concerns about your flower orders
            </p>
          </div>
        </section>

        {/* Contact Methods */}
        <section className="customer-service-contact-methods">
          <div className="customer-service-container">
            <div className="customer-service-section-header">
              <h2 className="customer-service-section-title">Get In Touch</h2>
              <p className="customer-service-section-description">
                Choose your preferred way to reach us
              </p>
            </div>
            <div className="customer-service-methods-grid">
              {contactMethods.map((method) => (
                <div key={method.id} className="customer-service-method-card">
                  <div className="customer-service-method-icon">{method.icon}</div>
                  <h3 className="customer-service-method-title">{method.title}</h3>
                  <p className="customer-service-method-description">{method.description}</p>
                  <p className="customer-service-method-contact">{method.contact}</p>
                  <p className="customer-service-method-hours">{method.hours}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="customer-service-faq">
          <div className="customer-service-container">
            <div className="customer-service-section-header">
              <h2 className="customer-service-section-title">Frequently Asked Questions</h2>
              <p className="customer-service-section-description">
                Find quick answers to common questions
              </p>
            </div>
            <div className="customer-service-faq-categories">
              {categories.map((category) => (
                <div key={category} className="customer-service-faq-category">
                  <h3 className="customer-service-faq-category-title">{category}</h3>
                  <div className="customer-service-faq-list">
                    {faqs
                      .filter((faq) => faq.category === category)
                      .map((faq) => (
                        <div
                          key={faq.id}
                          className={`customer-service-faq-item ${activeFaq === faq.id ? 'active' : ''}`}
                        >
                          <button
                            className="customer-service-faq-question"
                            onClick={() => toggleFaq(faq.id)}
                          >
                            <span>{faq.question}</span>
                            <svg
                              className="customer-service-faq-icon"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <polyline points="6 9 12 15 18 9" />
                            </svg>
                          </button>
                          <div className="customer-service-faq-answer">
                            <p>{faq.answer}</p>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="customer-service-form-section">
          <div className="customer-service-container">
            <div className="customer-service-form-wrapper">
              <div className="customer-service-form-info">
                <h2 className="customer-service-form-title">Still Have Questions?</h2>
                <p className="customer-service-form-description">
                  Fill out the form and our team will get back to you within 24 hours.
                </p>
                <div className="customer-service-form-features">
                  <div className="customer-service-form-feature">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>Quick response time</span>
                  </div>
                  <div className="customer-service-form-feature">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>Expert support team</span>
                  </div>
                  <div className="customer-service-form-feature">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>Personalized assistance</span>
                  </div>
                </div>
              </div>
              <form className="customer-service-form" onSubmit={handleSubmit}>
                <div className="customer-service-form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="John Doe"
                  />
                </div>
                <div className="customer-service-form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="john@example.com"
                  />
                </div>
                <div className="customer-service-form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select a topic</option>
                    <option value="order">Order Inquiry</option>
                    <option value="delivery">Delivery Issue</option>
                    <option value="quality">Product Quality</option>
                    <option value="payment">Payment Question</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="customer-service-form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="5"
                    placeholder="Tell us how we can help you..."
                  ></textarea>
                </div>
                <button type="submit" className="customer-service-form-submit">
                  Send Message
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14"/>
                    <path d="M12 5l7 7-7 7"/>
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* Support Info */}
        <section className="customer-service-support-info">
          <div className="customer-service-container">
            <div className="customer-service-support-cards">
              <div className="customer-service-support-card">
                <h3>📦 Order Tracking</h3>
                <p>Track your order in real-time and get delivery updates via email and SMS.</p>
              </div>
              <div className="customer-service-support-card">
                <h3>🌸 Care Instructions</h3>
                <p>Learn how to keep your flowers fresh and beautiful for as long as possible.</p>
              </div>
              <div className="customer-service-support-card">
                <h3>💯 Satisfaction Guarantee</h3>
                <p>We stand behind our quality with a 7-day freshness guarantee.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
